import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "vertical-flow__form__step" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "close",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        (_ctx.showMessage)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "message text-center",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeMessage()))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", {
                  class: "content",
                  innerHTML: _ctx.cms.globalMessageTxt
                }, null, 8, _hoisted_2),
                _hoisted_3
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}